import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';
import { AuthService } from 'src/app/Auth/AuthService';
import { environment } from '@env';

@Component({
  selector: 'app-forgotpassword',
  standalone: true,
  imports: [ReactiveFormsModule, RouterLink, CommonModule],
  templateUrl: './sendOTP.component.html',
  // styleUrl: './sendOTP.component.scss',
  styleUrls: ['./sendOTP.component.scss', '../../../../auth.scss'],

})
export class SENDOTPComponent implements OnInit {
  baseUrl = environment.baseUrl;
  ForgetPasswordForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private route: Router,
    private authService: AuthService,
    private pageService: PagesService,
    private sharedService: SharedService,
    private activaterouter: ActivatedRoute
  ) { }
  planData: any = null;
  ngOnInit(): void {
    this.ForgetPasswordForm = this.fb.group({
      PhoneNumber: ['', [Validators.required]],
    });
    // No token = no plan picked before signup (also how a resumed signup arrives from login).
    this.activaterouter.queryParams.subscribe(params => {
      const token = params['token'];
      try {
        this.planData = token ? JSON.parse(atob(token)) : null;
      } catch (err) {
        console.error('Invalid token format', err);
        this.planData = null;
      }
    });
  }

  handleOpt() {
    this.sharedService.showLoader();
    this.pageService.update('SEND_OPT', null).subscribe({
      next: (response: any) => {
        localStorage.setItem('optmail', response.email);
        localStorage.setItem('otp_expiry', response.otp_expiry_timestamp);
        this.sharedService.createNotification(
          'success',
          'Your OTP has been Sent successfully.'
        );
        this.sharedService.hideLoader();
        const token = btoa(JSON.stringify(this.planData));
        this.route.navigate(['/auth/verify-otp'], { queryParams: { token } });

      },
      // Without this a refusal (mail down, already verified) left the loader spinning forever.
      error: (err: any) => {
        this.sharedService.hideLoader();
        this.sharedService.createNotification(
          'error',
          err?.error?.message || 'Failed to send OTP. Please try again.'
        );
      },
    });
  }
}
